import React, { FunctionComponent } from 'react';

import { LandlordFullPageProps } from 'scenes/landlord/types';
import { getClaimsMade, getCoverType } from 'scenes/landlord/selectors';
import { ClaimsMadeStep as CommonClaimsMadeStep } from 'scenes/common/components/Steps';
import { CoverType } from 'scenes/common/types';

const question: {
  [key in CoverType]: string;
} = {
  [CoverType.BuildingAndContents]:
    'In the last 3 years, how many building and contents claims has the policy holder made?',
  [CoverType.Building]:
    'In the last 3 years, how many building claims has the policy holder made?',
  [CoverType.Contents]:
    'In the last 3 years, how many contents claims has the policy holder made?',
  [CoverType.Unspecified]:
    'In the last 3 years, how many building and contents claims has the policy holder made?',
};

const ClaimsMadeStep: FunctionComponent<LandlordFullPageProps> = ({
  funnelState,
  onNext,
}) => (
  <CommonClaimsMadeStep
    onNext={onNext}
    question={question[getCoverType(funnelState)]}
    defaultStateValue={getClaimsMade(funnelState)}
  />
);

export default ClaimsMadeStep;
